import { render, staticRenderFns } from "./AddMarketPlace.vue?vue&type=template&id=d1001a12"
import script from "./AddMarketPlace.vue?vue&type=script&lang=js"
export * from "./AddMarketPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports